/* eslint-disable @typescript-eslint/no-explicit-any */
import { useLocation, useNavigate } from "react-router-dom";
import { useCallback, useMemo } from "react";
interface NavigateState {
  usr?: string;
  state?: any;
  replace?: any;
}

interface UseHistoricalNavigateReturn {
  navigate: (route: string, stateArgs?: NavigateState) => void;
  stepBack: () => void;
  getPrevRoute: () => string | undefined;
}

export function useHistoricalNavigate(): UseHistoricalNavigateReturn {
  const navigate = useNavigate();
  const { pathname, state } = useLocation();

  const routeHistory = useMemo(() => state?.routeHistory || [], [state]);

  const navigateFunction = useCallback(
    (route: string, stateArgs?: NavigateState) => {
      const newState = { ...state, routeHistory: [...routeHistory, pathname], ...stateArgs };
      const options = stateArgs?.replace ? { state: newState, replace: true } : { state: newState };
      navigate(route, options);
    },
    [navigate, pathname, routeHistory, state]
  );

  const stepBackFunction = () => {
    const lastRoute = routeHistory.pop();
    const newState = { ...state, routeHistory };
    navigate(lastRoute || "/", { state: newState });
  };

  const getPrevRoute = (): string | undefined => {
    return routeHistory[routeHistory.length - 1];
  };

  return {
    navigate: navigateFunction,
    stepBack: stepBackFunction,
    getPrevRoute
  };
}
